<div class="personal-info">
    <h3>Change Password</h3>
    <p>Change your Password here.</p>
  </div>
  <hr class="custom-hr" />
<div class="change-password-container">

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <formly-form
      [model]="model"
      [fields]="fields"
      [options]="options"
      [form]="form"
    ></formly-form>

    <div style="margin-top: 32px;">
      <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
          <button
            pButton
            type="button"
            label="Reset"
            class="p-button cancel-button "
            (click)="onReset()"
          ></button>
        </div>
        <div class="flex align-items-center justify-content-center m-2">
          <button
            pButton
            type="submit"
            label="Save"
            class="p-button btn-primary save-button "
            [disabled]="form.invalid"
          ></button>
        </div>
      </div>
    </div>
  </form>
</div>
